<template>
	<div class="pb15">
		<div>
			<!-- Type -->
			<label for="type" class="block xs-12 lh125 mb1 fw7">
				{{ $t("type") }}
			</label>
			<j-base-input-text id="type" v-model="form.type" />

			<!-- Value -->
			<label for="value" class="block xs-12 lh125 mt4 mb1 fw7">
				{{ $t("value") }}
			</label>
			<j-base-input-text id="value" v-model="form.value" />
		</div>

		<!-- Buttons -->
		<div class="flex mt6 xs-between">
			<j-button :isLoading="isLoading" type="primary" @click="createContact">
				{{ $t("add") }}
			</j-button>
			<j-button
				:isDisabled="isLoading"
				type="bordered"
				@click="$emit('cancel')"
			>
				{{ $t("cancel") }}
			</j-button>
		</div>
	</div>
</template>

<script>
import JButton from "@/components/JButton"
import JBaseInputText from "@/components/JBaseInputText"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: {
		JButton,
		JBaseInputText
	},

	props: {
		entityId: {
			type: String
		},

		entityName: {
			type: String,
			default: ""
		},

		/**
		 * Instructions for creation of a new fact
		 * What properties it can included is in docs
		 */
		createOptions: {
			type: Object
		}
	},

	data() {
		return {
			isLoading: false,
			form: {
				dataType: "string",
				type: "",
				value: ""
			}
		}
	},

	methods: {
		init() {
			if (!this.createOptions) return

			// Populate creation form based on createOptions instructions
			this.form.type = this.createOptions?.type || ""
			this.form.value = this.createOptions?.value || ""
		},

		async createContact() {
			const query = gql`
				mutation addContact($entityId: String!, $input: addContactInput!) {
					addContact(entityId: $entityId, contactInput: $input) {
						status
						errors
						createdStatus {
							id
						}
					}
				}
			`

			this.isLoading = true
			const res = await api({
				query,
				variables: {
					entityId: this.entityId,
					input: { type: this.form.type, value: this.form.value }
				}
			})

			// Errors
			if (res?.data?.addContact?.status !== "success") {
				this.$store.dispatch(
					"showError",
					res?.data?.addContact?.errors?.[0] || this.$t("errors.general")
				)
				this.isLoading = false
				return
			}

			// Success
			this.isLoading = false
			this.form = { type: "", value: "" } // Reset form
			this.$emit("contact:created", res?.data?.addContact?.createdStatus?.id)
		}
	},

	created() {
		this.init()
	}
}
</script>
